import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const NotificationPreferencesModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "NotificationPreferencesModalContainer" */
      './NotificationPreferencesModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
